exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resultUser[data-v-6eebcb5c]{background:#ff5e4e;padding:16px 10px 20px;color:#fff;text-align:center}.resultUser__date[data-v-6eebcb5c]{font-weight:700;font-size:14px;line-height:14px;margin:0 0 10px}.resultUser__name[data-v-6eebcb5c]{font-weight:700;font-size:24px;line-height:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6eebcb5c","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/YearLuck/y2021/resultUser.vue
// module id = 360R
// module chunks = 0